import { fetchSectionResults, handleSectionResponse } from '../shared/singleSectionSearch.js';
import { renderPagination } from '../shared/pagination.js';
import { elements } from './elements.js';
import { hiddenClass, pgQueryParam, removeClass, addClass } from '../../../config.js';
import { getQueryParam, updateQueryString } from '../shared/utils.js';

const onPageLinkClick = (page) => {
    updateQueryString({ [pgQueryParam]: page });
    fetchResults(page);
};

export const fetchResults = (page = parseInt(getQueryParam(pgQueryParam)) || 1) => {
    removeClass(elements.loadingSkeletons, hiddenClass);
    addClass(elements.noResultsContainer, hiddenClass);
    addClass(elements.resultsContainer, hiddenClass);

    fetchSectionResults(
        'search/films',
        elements,
        page,
        (pagination) => renderPagination(pagination, onPageLinkClick),
        (response, resultsContainer) => {
            addClass(elements.loadingSkeletons, hiddenClass);
            handleSectionResponse(response, resultsContainer, elements.noResultsContainer, 'film-card-template', (card, film) => {
                const link = card.querySelector('a');
                link.href = film.url;

                card.querySelector('.js-film-card-image').src = film.cardImage || '';
                card.querySelector('.js-film-card-image').alt = film.title || '';
                card.querySelector('.js-film-card-title').textContent = film.title || 'Untitled';

                setOrHideTextContent(film.format, card, '.js-film-card-format');
                setOrHideTextContent(film.productionYear, card, '.js-film-card-year');
                setOrHideTextContent(film.genre, card, '.js-film-card-genre');
                setOrHideTextContent(film.region, card, '.js-film-card-region');
                setOrHideTextContent(film.availableToWatch ? 'Available to Watch' : null, card, '.js-film-card-available');
            });

            const totalResults = response.meta.pagination.total;
            const value = elements.searchInput.value;
            if (!value) {
                elements.resultCount.textContent = '';
            } else {
                elements.resultCount.textContent = `${totalResults} result${totalResults == 1 ? '' : 's'}${value && ` for ‘${value}’`}`;
            }
        }
    );
};

const setOrHideTextContent = (value, parent, selector) => {
    if (value) {
        parent.querySelector(selector).textContent = value;
    } else {
        parent.querySelector(selector).remove();
    }
}
